import { comparisonData } from "@/mocks/categories";

export default function WhatIsSection() {
  return (
    <section className="w-full px-4 md:px-6 lg:px-10 py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="lg:w-2/5">
            <span className="text-xs font-semibold uppercase tracking-wider text-primary-600 whitespace-nowrap">About</span>
            <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-5">
              What Is Superbuy Spreadsheet?
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              <strong>Superbuy Spreadsheet</strong> is a structured resource system that helps users organize product information, compare choices, review shopping details, and discover useful resources faster. Instead of jumping between dozens of browser tabs and losing track of products you love, Superbuy Spreadsheet brings everything into one organized view.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              Whether you&apos;re a first-time shopper looking to understand product quality, or an experienced buyer managing large product lists, Superbuy Spreadsheet transforms the way you research and decide. It&apos;s designed to save time, reduce confusion, and give you confidence in every purchase.
            </p>
            <p className="text-sm text-foreground-600 leading-relaxed">
              The spreadsheet approach has become the preferred method for thousands of smart shoppers who value organization, comparison, and data-driven decision making over chaotic, scattered browsing.
            </p>
          </div>

          <div className="lg:w-3/5 w-full overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="border-b border-background-300/60">
                  <th className="py-3 pr-4 text-xs font-semibold uppercase tracking-wider text-foreground-500 whitespace-nowrap">Category</th>
                  <th className="py-3 pr-4 text-xs font-semibold uppercase tracking-wider text-foreground-500 whitespace-nowrap">Traditional Search</th>
                  <th className="py-3 text-xs font-semibold uppercase tracking-wider text-primary-600 whitespace-nowrap">Superbuy Spreadsheet</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((row, idx) => (
                  <tr key={idx} className="border-b border-background-200/60">
                    <td className="py-3 pr-4 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.category}</td>
                    <td className="py-3 pr-4 text-xs text-foreground-500">{row.traditional}</td>
                    <td className="py-3 text-xs font-medium text-primary-700">{row.spreadsheet}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
}